<template>
  <van-popup class="loadPopup" v-model="show" :close-on-click-overlay="false">
    <div :class="this.mode" v-if="this.mode === 'loadingHardly'">
      <img src="../../../assets/loadingHardly.gif" />
      <div class="desc">自动加载中</div>
    </div>
    <div :class="this.mode" v-if="this.mode === 'autoCheck'">
      <img src="../../../assets/autoCheck.gif" />
      <div class="desc">自动处理中</div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "LoadPopup",
  data() {
    return {
      show: true
    };
  }
};
</script>

<style lang="less" scoped>
@import "../../../style/constant.less";

.loadPopup {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f7fbff;
  .loadingHardly {
    width: 150px;
    height: 85px;
  }
  .autoCheck {
    width: 140px;
    height: 135px;
  }
  img {
    width: 100%;
  }
  .desc {
    text-align: center;
    margin: 10px 0;
    color: @base-front-blue;
    font-size: @font-sm-size;
  }
}
</style>
